import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { FrameContext } from "../../contexts/FrameContext";
import firebaseApi from "../../apis/firebaseApi";
import dateHelpers from "../../helpers/dateHelpers";
import useTranslations from "../../hooks/useTranslations";
import useScheduleDay from "../../hooks/useScheduleDay";

const AppointmentCancel = () => {
  const { scheduleId } = useParams();
  const { companyId, source, currentUserId } = React.useContext(FrameContext);
  const [schedule, setSchedule] = React.useState();
  const [isMissing, setIsMissing] = React.useState(false);
  let history = useHistory();

  let content = useTranslations();

  React.useEffect(() => {
    if (!companyId || !scheduleId) return;
    firebaseApi.getAgentSchedule(companyId, scheduleId, async (data) => {
      if (!data.exists) {
        setIsMissing(true);
        return;
      }
      let schedule = { ...data.data(), id: data.id };
      setSchedule(schedule);

      if (schedule.agentId) {
        firebaseApi.getAgent(companyId, schedule.agentId, (d) => {
          let emailBody = {
            ...schedule,
            source: source.source,
            companySourceId: source.companyId,
            companyId: source.companyId,
            agentId: schedule.agentId,
            locationSourceId: source.locationId,
            slug: d.data().slug,
          };
          if (schedule.subsiteId) emailBody.subsiteId = schedule.subsiteId;
          if (schedule.brandId) emailBody.brandId = schedule.brandId;
          firebaseApi.sendCancelEmail(emailBody, () => {});
        });
      } else {
      }
      const lockDocId = `${schedule.agentId}_${schedule.schedule.startTime}`;
      await firebaseApi.deleteCompanySchedule(companyId, scheduleId, currentUserId, source.source, lockDocId, () => {});
    });
  }, [companyId, scheduleId]);

  const onRescheduleClick = () => {
    history.push("/agent");
  };

  let scheduleDay = useScheduleDay(schedule ? new Date(schedule.schedule.startTime * 1000) : null);

  if (isMissing) {
    return <div className="text-center mt-20">{content.cancelAppointment.error}</div>;
  }

  if (!schedule) return null;

  return (
    <div className="cts-scheduled">
      <h2>{content.cancelAppointment.header}</h2>
      <div>{content.cancelAppointment.body}</div>
      <hr />
      <div className="cts-schedule-date-container">
        <div className="cts-calendar-container cts-cancel">
          <i className="fas fa-calendar-star" />
        </div>
        <div className="cts-date-container">
          {/* Today<br /> */}
          <b>{scheduleDay}</b>
          <br />
          {dateHelpers.getTimeString(new Date(schedule.schedule.startTime * 1000))} - {dateHelpers.getTimeString(new Date(schedule.schedule.endTime * 1000), true)}
        </div>
      </div>
      <hr />
      {/* <div className="cts-schedule-buttons">
                <button type="button" className="btn btn-black"><i className="far fa-calendar-minus" /> Remove from Calendar</button>
            </div>
            <div>
                <button type="button" onClick={onRescheduleClick} className="btn-secondary">Reschedule</button>
            </div> */}
    </div>
  );
};

export default AppointmentCancel;
